import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "row g-3 mb-3" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row g-3 mb-3" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "row g-3 mb-3" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "row g-3 mb-3" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = ["for"]
const _hoisted_22 = ["id", "onUpdate:modelValue", "placeholder"]
const _hoisted_23 = { class: "row g-3 mb-3" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "onUpdate:modelValue"]
const _hoisted_27 = { value: "" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "row g-3 mb-3" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = ["for"]
const _hoisted_32 = ["id", "onUpdate:modelValue"]
const _hoisted_33 = { class: "row g-3 mb-3" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = ["for"]
const _hoisted_36 = ["id", "onUpdate:modelValue"]
const _hoisted_37 = {
  key: 0,
  class: "row g-3 mb-2"
}
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "text-muted" }
const _hoisted_40 = { class: "row g-3 mb-3" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = ["for"]
const _hoisted_43 = ["id", "onUpdate:modelValue", "placeholder"]
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = ["for"]
const _hoisted_46 = ["id", "onUpdate:modelValue", "placeholder"]
const _hoisted_47 = { class: "row g-3 mb-3" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = ["for"]
const _hoisted_50 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_51 = {
  key: 1,
  class: "row g-3 mb-3"
}
const _hoisted_52 = { class: "col-12" }
const _hoisted_53 = ["for"]
const _hoisted_54 = ["id", "onUpdate:modelValue"]
const _hoisted_55 = {
  key: 2,
  class: "row g-3 mb-3"
}
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = ["for"]
const _hoisted_58 = ["id", "onUpdate:modelValue"]
const _hoisted_59 = { value: null }
const _hoisted_60 = ["value"]
const _hoisted_61 = ["value"]
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "d-flex flex-column gap-2" }
const _hoisted_64 = { class: "d-flex gap-2" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "d-flex gap-2" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 1,
  class: "row g-3 mb-3"
}
const _hoisted_71 = { class: "col-12" }
const _hoisted_72 = {
  key: 2,
  class: "card"
}
const _hoisted_73 = { class: "card-header" }
const _hoisted_74 = { class: "mb-0" }
const _hoisted_75 = { class: "card-body" }
const _hoisted_76 = { class: "row g-3 mb-3" }
const _hoisted_77 = { class: "col-12" }
const _hoisted_78 = {
  for: "planType-editing",
  class: "form-label"
}
const _hoisted_79 = ["value"]
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "row g-3 mb-3" }
const _hoisted_82 = { class: "col-12" }
const _hoisted_83 = {
  for: "rewardType-editing",
  class: "form-label"
}
const _hoisted_84 = ["value"]
const _hoisted_85 = ["value"]
const _hoisted_86 = { class: "row g-3 mb-3" }
const _hoisted_87 = { class: "col-12" }
const _hoisted_88 = {
  for: "name",
  class: "form-label"
}
const _hoisted_89 = ["placeholder"]
const _hoisted_90 = { class: "row g-3 mb-3" }
const _hoisted_91 = { class: "col-12" }
const _hoisted_92 = {
  for: "currency",
  class: "form-label"
}
const _hoisted_93 = { value: "" }
const _hoisted_94 = ["value"]
const _hoisted_95 = { class: "row g-3 mb-3" }
const _hoisted_96 = { class: "col-12" }
const _hoisted_97 = {
  for: "planTimer",
  class: "form-label"
}
const _hoisted_98 = { class: "row g-3 mb-3" }
const _hoisted_99 = { class: "col-12" }
const _hoisted_100 = {
  for: "planCompletedDeal",
  class: "form-label"
}
const _hoisted_101 = { class: "row g-3 mb-3" }
const _hoisted_102 = { class: "col-md-6" }
const _hoisted_103 = {
  for: "planDealAmountMin-editing",
  class: "form-label"
}
const _hoisted_104 = ["placeholder"]
const _hoisted_105 = { class: "col-md-6" }
const _hoisted_106 = {
  for: "planDealAmountMax-editing",
  class: "form-label"
}
const _hoisted_107 = ["placeholder"]
const _hoisted_108 = { class: "row g-3 mb-3" }
const _hoisted_109 = { class: "col-12" }
const _hoisted_110 = {
  for: "allowedPaymentOptions-editing",
  class: "form-label"
}
const _hoisted_111 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_112 = {
  key: 0,
  class: "row g-3 mb-3"
}
const _hoisted_113 = { class: "col-12" }
const _hoisted_114 = {
  for: "planRequisiteLimit",
  class: "form-label"
}
const _hoisted_115 = {
  key: 1,
  class: "row g-3 mb-3"
}
const _hoisted_116 = { class: "col-12" }
const _hoisted_117 = {
  for: "rewardPriority-editing",
  class: "form-label"
}
const _hoisted_118 = { value: null }
const _hoisted_119 = ["value"]
const _hoisted_120 = ["value"]
const _hoisted_121 = ["value"]
const _hoisted_122 = { class: "d-flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.plan_settings'),
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.show = false)),
    size: "lg"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoaderWrapper, {
            key: 0,
            zoom: 0.5
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", {
                  class: "spinner-border",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ])
              ], -1)
            ])),
            _: 1,
            __: [17]
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disablePlanForAll && _ctx.disablePlanForAll(...args))),
                    class: "btn btn-outline-danger btn-sm"
                  }, _toDisplayString(_ctx.helper.trans('plan_settings.disable_plan_for_all_traders')), 1)
                ])
              ])
            ]),
            (_ctx.settings && _ctx.settings.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.helper.trans('plan_settings.current_settings')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings, (setting, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: setting.id || index,
                      class: "card mb-3"
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("label", {
                              for: `planType-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type')), 9, _hoisted_9),
                            _withDirectives(_createElementVNode("select", {
                              id: `planType-${setting.id}`,
                              class: "form-select",
                              "onUpdate:modelValue": ($event: any) => ((setting.planType) = $event)
                            }, [
                              _createElementVNode("option", {
                                value: _ctx.PlanType.MANDATORY
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type_mandatory')), 9, _hoisted_11),
                              _createElementVNode("option", {
                                value: _ctx.PlanType.OPTIONAL
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type_optional')), 9, _hoisted_12)
                            ], 8, _hoisted_10), [
                              [_vModelSelect, setting.planType]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("label", {
                              for: `rewardType-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_type')), 9, _hoisted_15),
                            _withDirectives(_createElementVNode("select", {
                              id: `rewardType-${setting.id}`,
                              class: "form-select",
                              "onUpdate:modelValue": ($event: any) => ((setting.rewardType) = $event),
                              onChange: ($event: any) => (_ctx.onCardRewardTypeChange(setting))
                            }, [
                              _createElementVNode("option", {
                                value: _ctx.PlanRewardType.UNLOCK_REQUISITES
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_type_unlock_requisites')), 9, _hoisted_17),
                              _createElementVNode("option", {
                                value: _ctx.PlanRewardType.PRIORITY_BOOST
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_type_priority_boost')), 9, _hoisted_18)
                            ], 40, _hoisted_16), [
                              [_vModelSelect, setting.rewardType]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("label", {
                              for: `name-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.name')), 9, _hoisted_21),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: `name-${setting.id}`,
                              "onUpdate:modelValue": ($event: any) => ((setting.name) = $event),
                              placeholder: _ctx.helper.trans('plan_settings.name_placeholder')
                            }, null, 8, _hoisted_22), [
                              [_vModelText, setting.name]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("label", {
                              for: `currency-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('labels.currency')), 9, _hoisted_25),
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              id: `currency-${setting.id}`,
                              "onUpdate:modelValue": ($event: any) => ((setting.currency) = $event)
                            }, [
                              _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.helper.trans('plan_settings.select_currency')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyList, (currency) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: currency,
                                  value: currency
                                }, _toDisplayString(currency), 9, _hoisted_28))
                              }), 128))
                            ], 8, _hoisted_26), [
                              [_vModelSelect, setting.currency]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("label", {
                              for: `planTimer-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.timer')) + " (" + _toDisplayString(_ctx.helper.trans('plan_settings.hours_minutes_seconds')) + ")", 9, _hoisted_31),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              class: "form-control",
                              id: `planTimer-${setting.id}`,
                              "onUpdate:modelValue": ($event: any) => ((setting.planTimerDisplay) = $event),
                              step: "1"
                            }, null, 8, _hoisted_32), [
                              [_vModelText, setting.planTimerDisplay]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("label", {
                              for: `planCompletedDeal-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.completed_deals')), 9, _hoisted_35),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-control",
                              id: `planCompletedDeal-${setting.id}`,
                              "onUpdate:modelValue": ($event: any) => ((setting.planCompletedDeal) = $event),
                              placeholder: "0"
                            }, null, 8, _hoisted_36), [
                              [_vModelText, setting.planCompletedDeal]
                            ])
                          ])
                        ]),
                        (_ctx.getDealAmountRangeText(setting))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("small", _hoisted_39, _toDisplayString(_ctx.getDealAmountRangeText(setting)), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", {
                              for: `planDealAmountMin-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_deal_amount_min')), 9, _hoisted_42),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: `planDealAmountMin-${setting.id}`,
                              "onUpdate:modelValue": ($event: any) => ((setting.planDealAmountMinDisplay) = $event),
                              placeholder: _ctx.helper.trans('plan_settings.plan_deal_amount_min')
                            }, null, 8, _hoisted_43), [
                              [_vModelText, setting.planDealAmountMinDisplay]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("label", {
                              for: `planDealAmountMax-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_deal_amount_max')), 9, _hoisted_45),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: `planDealAmountMax-${setting.id}`,
                              "onUpdate:modelValue": ($event: any) => ((setting.planDealAmountMaxDisplay) = $event),
                              placeholder: _ctx.helper.trans('plan_settings.plan_deal_amount_max')
                            }, null, 8, _hoisted_46), [
                              [_vModelText, setting.planDealAmountMaxDisplay]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("label", {
                              for: `allowedPaymentOptions-${setting.id}`,
                              class: "form-label"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.allowed_payment_options')), 9, _hoisted_49),
                            _createVNode(_component_Multiselect, {
                              id: `allowedPaymentOptions-${setting.id}`,
                              class: "",
                              modelValue: setting.allowedPaymentOptions,
                              "onUpdate:modelValue": ($event: any) => ((setting.allowedPaymentOptions) = $event),
                              options: _ctx.paymentOptionsList(setting.currency),
                              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('plan_settings.select_payment_methods')
                            }, {
                              option: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + props.option)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["id", "modelValue", "onUpdate:modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ]),
                        (setting.rewardType !== _ctx.PlanRewardType.PRIORITY_BOOST)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("label", {
                                  for: `planRequisiteLimit-${setting.id}`,
                                  class: "form-label"
                                }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_requisite_limit')), 9, _hoisted_53),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: `planRequisiteLimit-${setting.id}`,
                                  "onUpdate:modelValue": ($event: any) => ((setting.planRequisiteLimitDisplay) = $event),
                                  placeholder: "0.00"
                                }, null, 8, _hoisted_54), [
                                  [_vModelText, setting.planRequisiteLimitDisplay]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (setting.rewardType === _ctx.PlanRewardType.PRIORITY_BOOST)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("label", {
                                  for: `rewardPriority-${setting.id}`,
                                  class: "form-label"
                                }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority')), 9, _hoisted_57),
                                _withDirectives(_createElementVNode("select", {
                                  id: `rewardPriority-${setting.id}`,
                                  class: "form-select",
                                  "onUpdate:modelValue": ($event: any) => ((setting.rewardPriority) = $event)
                                }, [
                                  _createElementVNode("option", _hoisted_59, _toDisplayString(_ctx.helper.trans('plan_settings.not_set')), 1),
                                  _createElementVNode("option", {
                                    value: _ctx.PlanRewardPriority.HIGH
                                  }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority_high')), 9, _hoisted_60),
                                  _createElementVNode("option", {
                                    value: _ctx.PlanRewardPriority.MEDIUM
                                  }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority_medium')), 9, _hoisted_61),
                                  _createElementVNode("option", {
                                    value: _ctx.PlanRewardPriority.LOW
                                  }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority_low')), 9, _hoisted_62)
                                ], 8, _hoisted_58), [
                                  [_vModelSelect, setting.rewardPriority]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.enablePlanForSetting(setting.id)),
                              class: "btn btn-outline-secondary btn-sm"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.enable_plan_for_setting')), 9, _hoisted_65),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.disablePlanForSetting(setting.id)),
                              class: "btn btn-outline-secondary btn-sm"
                            }, _toDisplayString(_ctx.helper.trans('plan_settings.disable_plan_for_setting')), 9, _hoisted_66)
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.updateSetting(setting)),
                              class: "btn btn-outline-primary btn-sm"
                            }, _toDisplayString(_ctx.helper.trans('button.save')), 9, _hoisted_68),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.deleteSetting(setting)),
                              class: "btn btn-outline-danger btn-sm"
                            }, _toDisplayString(_ctx.helper.trans('button.delete')), 9, _hoisted_69)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.editingSetting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewSetting && _ctx.addNewSetting(...args))),
                      class: "btn btn-outline-success btn-sm"
                    }, _toDisplayString(_ctx.helper.trans('button.add_new_setting')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editingSetting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("h6", _hoisted_74, _toDisplayString(_ctx.editingSetting.id ? _ctx.helper.trans('button.edit_setting') : _ctx.helper.trans('button.add_new_setting')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type')), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "planType-editing",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingSetting.planType) = $event))
                        }, [
                          _createElementVNode("option", {
                            value: _ctx.PlanType.MANDATORY
                          }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type_mandatory')), 9, _hoisted_79),
                          _createElementVNode("option", {
                            value: _ctx.PlanType.OPTIONAL
                          }, _toDisplayString(_ctx.helper.trans('plan_settings.plan_type_optional')), 9, _hoisted_80)
                        ], 512), [
                          [_vModelSelect, _ctx.editingSetting.planType]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.helper.trans('plan_settings.reward_type')), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "rewardType-editing",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingSetting.rewardType) = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onEditingRewardTypeChange()))
                        }, [
                          _createElementVNode("option", {
                            value: _ctx.PlanRewardType.UNLOCK_REQUISITES
                          }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_type_unlock_requisites')), 9, _hoisted_84),
                          _createElementVNode("option", {
                            value: _ctx.PlanRewardType.PRIORITY_BOOST
                          }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_type_priority_boost')), 9, _hoisted_85)
                        ], 544), [
                          [_vModelSelect, _ctx.editingSetting.rewardType]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.helper.trans('plan_settings.name')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "name",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingSetting.name) = $event)),
                          placeholder: _ctx.helper.trans('plan_settings.name_placeholder')
                        }, null, 8, _hoisted_89), [
                          [_vModelText, _ctx.editingSetting.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          id: "currency",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingSetting.currency) = $event))
                        }, [
                          _createElementVNode("option", _hoisted_93, _toDisplayString(_ctx.helper.trans('plan_settings.select_currency')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyList, (currency) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: currency,
                              value: currency
                            }, _toDisplayString(currency), 9, _hoisted_94))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.editingSetting.currency]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.helper.trans('plan_settings.timer')) + " (" + _toDisplayString(_ctx.helper.trans('plan_settings.hours_minutes_seconds')) + ")", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "time",
                          class: "form-control",
                          id: "planTimer",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingSetting.planTimerDisplay) = $event)),
                          step: "1"
                        }, null, 512), [
                          [_vModelText, _ctx.editingSetting.planTimerDisplay]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.helper.trans('plan_settings.completed_deals')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          id: "planCompletedDeal",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingSetting.planCompletedDeal) = $event)),
                          placeholder: "0"
                        }, null, 512), [
                          [_vModelText, _ctx.editingSetting.planCompletedDeal]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.helper.trans('plan_settings.plan_deal_amount_min')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "planDealAmountMin-editing",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editingSetting.planDealAmountMinDisplay) = $event)),
                          placeholder: _ctx.helper.trans('plan_settings.plan_deal_amount_min')
                        }, null, 8, _hoisted_104), [
                          [_vModelText, _ctx.editingSetting.planDealAmountMinDisplay]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.helper.trans('plan_settings.plan_deal_amount_max')), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "planDealAmountMax-editing",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editingSetting.planDealAmountMaxDisplay) = $event)),
                          placeholder: _ctx.helper.trans('plan_settings.plan_deal_amount_max')
                        }, null, 8, _hoisted_107), [
                          [_vModelText, _ctx.editingSetting.planDealAmountMaxDisplay]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.helper.trans('plan_settings.allowed_payment_options')), 1),
                        _createVNode(_component_Multiselect, {
                          id: "allowedPaymentOptions-editing",
                          class: "",
                          modelValue: _ctx.editingSetting.allowedPaymentOptions,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingSetting.allowedPaymentOptions) = $event)),
                          options: _ctx.paymentOptionsList(_ctx.editingSetting.currency),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('plan_settings.select_payment_methods')
                        }, {
                          option: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('payment_options.' + props.option)), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ]),
                    (_ctx.editingSetting.rewardType !== _ctx.PlanRewardType.PRIORITY_BOOST)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.helper.trans('plan_settings.plan_requisite_limit')), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "planRequisiteLimit",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingSetting.planRequisiteLimitDisplay) = $event)),
                              placeholder: "0.00"
                            }, null, 512), [
                              [_vModelText, _ctx.editingSetting.planRequisiteLimitDisplay]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.editingSetting.rewardType === _ctx.PlanRewardType.PRIORITY_BOOST)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority')), 1),
                            _withDirectives(_createElementVNode("select", {
                              id: "rewardPriority-editing",
                              class: "form-select",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editingSetting.rewardPriority) = $event))
                            }, [
                              _createElementVNode("option", _hoisted_118, _toDisplayString(_ctx.helper.trans('plan_settings.not_set')), 1),
                              _createElementVNode("option", {
                                value: _ctx.PlanRewardPriority.HIGH
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority_high')), 9, _hoisted_119),
                              _createElementVNode("option", {
                                value: _ctx.PlanRewardPriority.MEDIUM
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority_medium')), 9, _hoisted_120),
                              _createElementVNode("option", {
                                value: _ctx.PlanRewardPriority.LOW
                              }, _toDisplayString(_ctx.helper.trans('plan_settings.reward_priority_low')), 9, _hoisted_121)
                            ], 512), [
                              [_vModelSelect, _ctx.editingSetting.rewardPriority]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveSetting && _ctx.saveSetting(...args))),
                        class: "btn btn-outline-primary btn-sm"
                      }, _toDisplayString(_ctx.helper.trans('button.save')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args))),
                        class: "btn btn-outline-secondary btn-sm"
                      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}